let selectMenu = document.querySelector('#ContactForm-contact_reason')
let appSelectMenu = document.querySelector('#ContactForm-app_name')

let hiddenTechFields = document.querySelector('.hidden-technical-fields')
selectMenu.addEventListener('change', (evt) => {
    if (evt.target.value == 'App Issue') {
        $('#ContactForm-app_name').prop('required', true);
        $(hiddenTechFields).slideDown({duration : 300});
    } else {
        $('#ContactForm-app_name').prop('required', false);
        $(hiddenTechFields).slideUp({duration : 300});
    }
});

let hiddenProdFields = document.querySelector('.hidden-product-fields')
selectMenu.addEventListener('change', (evt) => {
    if (evt.target.value == 'Product Inquiry') {
        $(hiddenProdFields).slideDown({duration : 300});
    } else {
        $(hiddenProdFields).slideUp({duration : 300});
    }
});

let activationCodeField = document.querySelector('.activation-code-field')
appSelectMenu.addEventListener('change', (evt) => {
    let selectedCode = $(appSelectMenu.options[appSelectMenu.selectedIndex]).data('code')
    if (selectedCode == true) {
        $(activationCodeField).slideDown({duration : 300});
    } else {
        $(activationCodeField).slideUp({duration : 300});
    }
});
